import React from 'react';
import { THEME_CONFIG } from '../constants';
import { Facebook, Twitter, Instagram } from 'lucide-react';

const SocialIcon: React.FC<{ href: string, children: React.ReactNode }> = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300">
    {children}
  </a>
);

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary text-gray-300 pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold text-white mb-4">{THEME_CONFIG.clinicName}</h3>
            <p className="text-sm text-gray-400">Tu bienestar, nuestra prioridad.</p>
            <div className="flex space-x-4 mt-6">
                <SocialIcon href="#">
                    <Facebook />
                </SocialIcon>
                <SocialIcon href="#">
                     <Twitter />
                </SocialIcon>
                 <SocialIcon href="#">
                   <Instagram />
                </SocialIcon>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="text-gray-400 hover:text-white transition-colors">Inicio</a></li>
              <li><a href="/services" className="text-gray-400 hover:text-white transition-colors">Servicios</a></li>
              <li><a href="/faq" className="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white transition-colors">Contacto</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Acerca de Nosotros</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/about" className="text-gray-400 hover:text-white transition-colors">Sobre Nosotros</a></li>
              <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors">Blog</a></li>
              <li><a href="/specialists" className="text-gray-400 hover:text-white transition-colors">Especialistas</a></li>
              <li><a href="/booking" className="text-gray-400 hover:text-white transition-colors">Reservas</a></li>
            </ul>
          </div>
           <div>
            <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/legal" className="text-gray-400 hover:text-white transition-colors">Aviso Legal</a></li>
              <li><a href="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Política de Privacidad</a></li>
              <li><a href="/terms" className="text-gray-400 hover:text-white transition-colors">Términos de Servicio</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Suscríbete</h4>
            <p className="text-sm text-gray-400 mb-4">Recibe consejos de salud directamente en tu correo.</p>
            <form className="flex">
              <input type="email" placeholder="Tu email" className="w-full px-4 py-2 text-gray-800 bg-gray-100 rounded-l-xl focus:outline-none" />
              <button 
                type="submit" 
                name="Suscríbete" 
                id="Suscríbete"
                aria-label="Suscríbete"
                className="bg-primary text-white px-4 py-2 rounded-r-xl font-semibold hover:bg-opacity-90 transition-colors">
                &rarr;
              </button>
            </form>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-700 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} {THEME_CONFIG.clinicName}. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;